<div id="tituloPaginaMeuCadastro" class="app-titulo-pagina-v2">
    <img src="../../../assets/img/icons/bt_cadastro.png" alt="Icone de btn_cadastros">
    <span>Meu cadastro</span>
</div>
<div class="container">
<app-submenu></app-submenu>


<app-form></app-form>

</div>


// WEBPACK FOOTER //
// ./src/app/menu-superior/meu-cadastro/meu-cadastro.component.html